<template>
  <div class="home">
    <Hero />
    <Features />
    <div class="calendar-note py-4 bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 text-center">
            <div class="alert alert-info border-0 shadow-sm">
              <i class="bi bi-calendar-check me-2"></i>
              <strong>Novità:</strong> Sia per Auto che Immobili, è disponibile un calendario integrato
              per il tracking di tutti gli interventi di manutenzione e appuntamenti
            </div>
          </div>
        </div>
      </div>
    </div>
    <CallToAction />
  </div>
</template>

<script>
import Hero from '@/components/home/Hero.vue'
import Features from '@/components/home/Features.vue'
import CallToAction from '@/components/home/CallToAction.vue'

export default {
  name: 'HomeView',
  components: {
    Hero,
    Features,
    CallToAction
  }
}
</script>

<style scoped>
.home {
  overflow-x: hidden; /* Per gestire eventuali animazioni */
}

/* Aggiungiamo stili per elementi hero e sezioni */
.hero {
  background: #219ebc !important; /* Azzurro medio */
  color: #fff;
}

/* Pattern geometrico in overlay */
.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(135deg,
    rgba(142, 202, 230, 0.1) 25%,
    transparent 25%,
    transparent 50%,
    rgba(142, 202, 230, 0.1) 50%,
    rgba(142, 202, 230, 0.1) 75%,
    transparent 75%,
    transparent);
  background-size: 30px 30px;
}

/* Sezione Dashboard */
.dashboard-section {
  background: #fff;
}

/* Bottoni di selezione */
.btn-primary {
  background: #219ebc !important;
  border-color: #219ebc !important;
}

.btn-primary:hover {
  background: #023047 !important;
  border-color: #023047 !important;
}

/* Badge e pills */
.badge {
  background: #ffb703 !important;
  color: #023047 !important;
}

/* Cards e box */
.feature-box {
  background: #fff;
  border: 1px solid #8ecae6;
}

.feature-box:hover {
  border-color: #219ebc;
}

/* Icone */
.feature-icon {
  color: #fb8500 !important;
}

.calendar-note {
  background: linear-gradient(to right, rgba(142, 202, 230, 0.1), rgba(33, 158, 188, 0.1));
}

.alert-info {
  background: #fff;
  border-left: 4px solid #219ebc !important;
  color: #023047;
}
</style>
